import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {AddressForm} from "../../../../../common/AddressForm.jsx";
import {wrapInSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {apiCreateAddress, apiEditAddress} from "../../../../../../client/state/UserAddressStore";
import {FlowInputIntent} from "../../../../flows/steps/BaseFlowStep.jsx";
import {Flow} from "../../../../flows/Flow.js";


export class AddOrEditAddressComponent extends UI.Element {
    render() {
        const address = this.getEditingAddress();
        return <AddressForm ref="form" address={address}/>;
    }

    getEditingAddress() {
        return Flow.address.inputIntent === FlowInputIntent.EDIT_VALUE ? Flow.address.selectedValue : null;
    }

    isValid() {
        return true;
    }

    @wrapInSpinner
    async getAddress() {
        if (!this.form.validateInputs()) {
            return null;
        }
        try {
            const payload = this.form.getValues();
            const editingAddress = this.getEditingAddress();

            if (editingAddress) {
                return await apiEditAddress({
                    ...payload,
                    userAddressId: editingAddress.id
                });
            }

            return await apiCreateAddress(payload);
        } catch (error) {
            if (error?.fields) {
                this.form.displayFieldErrors(error);
            }
        }

        // We failed at validation
        return null;
    }
}
